import { Flex } from "styled-system/jsx";
import { Spinner, Text } from "@ttc3k/trekker";
import { useTranslation } from "react-i18next";

export const SimpleLoader = () => {
  const { t } = useTranslation();
  return (
    <Flex alignItems={"center"} gap={"100"}>
      <Spinner width={"20px"} height={"20px"} />
      <Text visual={"bodyMedium"} color={"text.mid"}>
        {t("core:LOADING") + "..."}
      </Text>
    </Flex>
  );
};
